const measureTypes = [
    {
        name: "SQUARE_METERS",
        value: 1
    },
    {
        name: "PIECES",
        value: 2
    },
    {
        name: "PAUSCHALS",
        value: 3
    },
    {
        name: "CUBIC METRES",
        value: 4
    },
    {
        name: "RUNNING METRES",
        value: 5
    },
    {
        name: "HOURS",
        value: 6
    },
    {
        name: "PACKAGES",
        value: 7
    },
    {
        name: "KILOGRAMS",
        value: 8
    },
    {
        name: "TONNES",
        value: 9
    },
    {
        name: "BAGS",
        value: 10
    },
    {
        name: "LITRES",
        value: 11
    }

];

export default measureTypes;